import React from "react";
import { Button, CardActions, Divider, Grid } from "@material-ui/core";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { Users as UsersIcon } from "react-feather";
import CardStatus from "../../components/CardStatus";
import CardDashboard from "../../components/CardDashboard";
import { useTranslation } from "react-i18next";

const CustomerCard = ({ customers, action }) => {
  const { t } = useTranslation();

  const notActive = customers.filter((obj) => obj.is_active === false).length;
  const active = customers.filter((obj) => obj.is_active === true).length;

  return (
    <CardDashboard
      title={t("customer_card.title")}
      value={customers.length}
      avatar={<UsersIcon />}
      action={
        action ? (
          <>
            <Divider />
            <CardActions>
              <Button
                color="primary"
                fullWidth
                variant="text"
                endIcon={<ArrowRightIcon />}
                onClick={action}
              >
                {t("customer_card.action")}{" "}
              </Button>
            </CardActions>
          </>
        ) : null
      }
    >
      <Grid container style={{ paddingTop: "1.25rem" }}>
        <Grid item xs={6}>
          <CardStatus
            type="down"
            title={t("customer_card.not_active")}
            value={notActive}
          />
        </Grid>
        <Grid item xs={6}>
          <CardStatus
            type="up"
            title={t("customer_card.active")}
            value={active}
          />
        </Grid>
      </Grid>
    </CardDashboard>
  );
};

export default CustomerCard;
